export const validatePassword = (password, required) => {
  if (!password) {
    return !required
  }

  if (password.length < 8) return false

  if (!/[a-zA-Z]/.test(password)) return false
  if (!/[0-9]/.test(password)) return false
  if (!/[!@#$%^&*()_\-+=[\]{};:'",.<>/?\\|]/.test(password)) return false

  return true
}
